import React from 'react';

interface LineButtonProps {
  text: string;
  onClick?: () => void;
  icon?: 'plus' | 'edit';
  disabled?: boolean;
}

const LineButton: React.FC<LineButtonProps> = ({ text, onClick, icon = 'plus', disabled = false }) => {
  const iconSvg = icon === 'plus' ? (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 3.33334V12.6667M3.33337 8H12.6667" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M7.33333 2.66667H2.66667C2.29848 2.66667 1.94519 2.81429 1.68215 3.07733C1.41905 3.34048 1.27148 3.69381 1.27148 4.062V13.3333C1.27148 13.7015 1.41905 14.0549 1.68215 14.318C1.94519 14.581 2.29848 14.7286 2.66667 14.7286H12C12.3682 14.7286 12.7214 14.581 12.9845 14.318C13.2476 14.0549 13.3952 13.7015 13.3952 13.3333V8.66667M12.3333 1.60952C12.6203 1.32262 13.0131 1.16071 13.4238 1.16071C13.8345 1.16071 14.2274 1.32262 14.5143 1.60952C14.8012 1.89643 14.9631 2.28929 14.9631 2.7C14.9631 3.11071 14.8012 3.50357 14.5143 3.79048L8 10.3048L5.33333 11L6.02857 8.33333L12.3333 1.60952Z" stroke="#6750B8" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <button className="line-button" onClick={onClick} disabled={disabled}>
      {/* {iconSvg} */}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#6750B8" strokeWidth="2" />
                <path d="M12 8v8M8 12h8" stroke="#6750B8" strokeWidth="2" strokeLinecap="round" />
              </svg>
      <span className="line-button-text">{text}</span>
    </button>
  );
};

export default LineButton;